// extracted by mini-css-extract-plugin
export default {"newchat-main":"NewChat_newchat-main__jSsWJ","text-section":"NewChat_text-section__Rrrxa","gradientAnimation":"NewChat_gradientAnimation__gNlDu"};